
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter: JSON.stringify([new Filter("courseItemGroupId", +this.$route.params.id)]),
    },
    className: "CourseItem",
  });

  companyObjectDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "CourseItemGroup",
  });
  loaded: boolean = false;

  createItemModel: any = {
    companyId: +this.$route.params.id,
    caption: "",
    price: "",
  };

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Раздел курсов",
        to: "/manage/courses/",
        exact: true,
      },
      {
        text: this.companyObjectDataSource.model?.caption,
        to: `/manage/courses/${+this.$route.params.id}`,
        exact: true,
      },
      {
        text: "Курсы",
        to: `/manage/courses/${+this.$route.params.id}/course-items/`,
        exact: true,
      },
    ];
  }

  created() {
    this.companyObjectDataSource.get();
    
    console.log(this.companyObjectDataSource);
  }
}
